import type { RedoMerchantRpcClient } from "@redotech/merchant-sdk/rpc/client";
import { hasDisputeScopes } from "@redotech/redo-dispute-common/dispute-scopes";
import type { Team } from "@redotech/redo-model/team";

export const RECLAIM_SHOPIFY_PERMISSIONS_STEP_ID = "shopify-permissions";

export const RECLAIM_SHOPIFY_PERMISSIONS_COPY = {
  title: "Update Shopify permissions",
  body: "Reclaim needs Shopify dispute permissions to find chargebacks, generate evidence, and submit responses for you.",
  ctaText: "Update permissions",
  missingAfterReturn:
    "Shopify permissions still need to be updated before Reclaim can activate. Please try again.",
  urlError: "Could not open Shopify permissions. Please try again.",
};

export function hasReclaimShopifyPermissions(
  team: Pick<Team, "accessScope"> | null | undefined,
): boolean {
  return (
    process.env.NODE_ENV === "development" ||
    hasDisputeScopes(team?.accessScope ?? [])
  );
}

export function buildReclaimShopifyPermissionsReturnPath(): string {
  const params = new URLSearchParams({
    setupStep: RECLAIM_SHOPIFY_PERMISSIONS_STEP_ID,
  });
  return `/finance/disputes/dashboard?${params.toString()}`;
}

export async function getReclaimShopifyPermissionsAuthorizationUrl({
  rpcClient,
}: {
  rpcClient: Pick<RedoMerchantRpcClient, "getShopifyPermissionsUpdateUrl">;
}): Promise<string> {
  const { authorizationUrl } = await rpcClient.getShopifyPermissionsUpdateUrl({
    nextPath: buildReclaimShopifyPermissionsReturnPath(),
  });
  return authorizationUrl;
}

export async function openReclaimShopifyPermissionsAuthorizationUrl({
  nextPath,
  rpcClient,
}: {
  nextPath: string;
  rpcClient: Pick<RedoMerchantRpcClient, "getShopifyPermissionsUpdateUrl">;
}): Promise<void> {
  const { authorizationUrl } = await rpcClient.getShopifyPermissionsUpdateUrl({
    nextPath,
  });
  window.location.href = authorizationUrl;
}
